import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import PhoneIcon from "@mui/icons-material/Phone";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import EmailIcon from "@mui/icons-material/Email";
import BusinessIcon from "@mui/icons-material/Business";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import logo from "../assets/jjs_waste_final_web_rgb.png";
import OfficeMap from "./OfficeMap";

// Use Azure Static Web App environment variable in production, .env in development
const ANYDESK_WINDOWS_DOWNLOAD_URL = 
  process.env.REACT_APP_ANYDESK_WINDOWS_DOWNLOAD_URL;

// Log for debugging (remove in production if needed)
if (process.env.NODE_ENV === 'development') {
  console.log('AnyDesk URL available:', !!ANYDESK_WINDOWS_DOWNLOAD_URL);
  console.log('AnyDesk URL value:', ANYDESK_WINDOWS_DOWNLOAD_URL);
}

// Warn if no URL found
if (!ANYDESK_WINDOWS_DOWNLOAD_URL) {
  console.warn('WARNING: REACT_APP_ANYDESK_WINDOWS_DOWNLOAD_URL environment variable is not set');
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://www.jjswaste.com.au/">
        JJs Waste & Recycling Pty Ltd
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  button: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
    textAlign: "center",
  },
  container: {
    padding: theme.spacing(4),
  },
  appbar: {
    alignItems: "center",
  },
  img: {
    width: "100%",
    height: "auto",
  },
}));

export default function Album() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar className={classes.appbar} position="relative">
        <Toolbar>
          <Typography variant="h6" color="inherit" noWrap>
            JJs Waste & Recycling IT Support
          </Typography>
        </Toolbar>
      </AppBar>
      <Container className={classes.container}>
        <Grid container spacing={3} sx={{ alignItems: "stretch" }}>
          <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
            <Paper className={classes.paper} sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
              <img className={classes.img} src={logo} alt="JJs Waste Logo" />
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
            <Paper className={classes.paper} sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
              <List component="nav">
                <ListItemLink href="tel:+61734889635">
                  <ListItemIcon>
                    <PhoneIcon />
                  </ListItemIcon>
                  <ListItemText primary="+61 7 3488 9635" />
                </ListItemLink>
                <ListItemLink href="mailto:servicedesk@jjswaste.com.au">
                  <ListItemIcon>
                    <EmailIcon />
                  </ListItemIcon>
                  <ListItemText primary="servicedesk@jjswaste.com.au" />
                </ListItemLink>
                <ListItemLink
                  href="https://maps.google.com/maps?ll=-27.525232,153.252647&z=15&t=m&hl=en-US&gl=US&mapclient=embed&cid=111981598961952257"
                  target="_blank"
                >
                  <ListItemIcon>
                    <BusinessIcon />
                  </ListItemIcon>
                  <ListItemText primary="1/3 Grant Street, Cleveland, QLD, Australia, 4163" />
                </ListItemLink>
                <ListItemLink
                  href="https://www.jjrichards.com.au/notice/"
                  target="_blank"
                >
                  <ListItemIcon>
                    <LiveHelpIcon />
                  </ListItemIcon>
                  <ListItemText primary="Work from home information" />
                </ListItemLink>
              </List>
              <OfficeMap />
            </Paper>
          </Grid>
          <Grid container spacing={2} justifyContent="center" sx={{ mt: 2, px: 2 }}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={handleClickOpen}
              >
                Download Remote Support Software
              </Button>
            </Grid>
          </Grid>
          <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
          >
            <DialogTitle id="simple-dialog-title">Choose an option</DialogTitle>
            <Grid container spacing={2} justifyContent="center" sx={{ p: 2 }}>
                <Grid item xs={12} sm={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    component="a"
                    href={ANYDESK_WINDOWS_DOWNLOAD_URL}
                    download
                    disabled={!ANYDESK_WINDOWS_DOWNLOAD_URL}
                  >
                    Windows
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    component="a"
                    href="https://get.anydesk.com/RGc81AbU/AnyDesk_macOS_Client.dmg"
                    download
                  >
                    macOS
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    href="https://play.google.com/store/apps/details?id=com.anydesk.anydeskandroid&hl=en_AU"
                    target="_blank"
                  >
                    Android
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    href="https://apps.apple.com/us/app/anydesk/id1176131273"
                    target="_blank"
                  >
                    iOS
                  </Button>
                </Grid>
            </Grid>
          </Dialog>
        </Grid>
      </Container>
      <footer className={classes.footer}>
        <Copyright />
      </footer>
    </React.Fragment>
  );
}